<template>
  <InteractionStep :disabled-next="!showNext"
                   :pending-next="pendingSave"
                   @next="onSave">
    <template v-slot:content>
      <div class="step-confirm">
        <h4 class="step-confirm__title">{{ $tInteraction('Documents are on the way for you') }}</h4>
        <div class="step-confirm__text text">
          <p>{{
              $tInteraction('We have prepared and sent you a package of documents that must be submitted to the visa center')
            }}</p>
        </div>

        <div class="step-confirm__alert">
          <div class="step-confirm__alert-text text">
            <p>{{ $tInteraction('You have been assigned a date to visit the Visa Application Center') }}
              <b>{{ dateString }}</b> {{
                $tInteraction('at')
              }}
              <b>{{ timeString }}</b><br>
              {{ $tInteraction(`Don't be late!`) }}</p>
          </div>
        </div>

        <div class="step-confirm__center">
          <h4 class="step-confirm__title">{{ $tInteraction('Before the visit to the visa center there are') }}</h4>

          <TimerSmall :end-time="visitDate"
                      class="step-confirm__timer"
          />

          <label :class="isDisabled ? '_disabled' :  null"
                 class="step-confirm__checkbox checkbox">
            <input type="radio"
                   name="type-option"
                   v-model="checked"
                   :value="1"
                   hidden>
            <span class="checkbox__mark">
              <BaseSvg name="ico-check"/>
            </span>
            <span class="checkbox__text">{{ $tInteraction('I went to the Visa Application Center') }}</span>
          </label>
        </div>

      </div>

      <BaseAlert :value="error" class="step-contract__error  _error"/>
    </template>
  </InteractionStep>
</template>

<script>
  import InteractionStep from '@/components/interactions/InteractionStep'
  import TimerSmall from '@/components/TimerSmall'
  import {http} from '@/axios'
  import interactionStepMixin from "@/mixins/interactionStepMixin"

  let timer = null

  export default {
    name: 'InteractionStepVisitWaiting',
    mixins: [interactionStepMixin],
    components: {TimerSmall, InteractionStep},
    data() {
      return {
        currentDate: new Date(),
        pendingSave: false,
        error: null,
        checked: false
      }
    },
    computed: {
      visitDate() {
        return new Date(this.$store.state.interaction.data.visa_visit_date)
      },
      isDisabled() {
        return this.visitDate > this.currentDate
      },
      dateString() {
        return this.visitDate.toLocaleDateString()
      },
      timeString() {
        return this.visitDate.toLocaleTimeString()
      },
      showNext() {
        return !this.isDisabled && this.checked
      }
    },
    methods: {
      onSave() {
        this.error = null
        this.pendingSave = true

        const step = this.$store.state.interaction.step

        http.post(`/api/new-interaction/${this.$route.params.id}/${step}`, {
          i_went_visa_center: 1
        }).then(async () => {
          await this.$store.dispatch('interaction/loadInteraction')
        }).catch(e => {
          this.handleInteractionError(e)
        }).finally(() => {
          this.pendingSave = false
        })
      },
    },
    created() {
      timer = setInterval(() => {
        this.currentDate = new Date()
      }, 10000)
    },
    beforeDestroy() {
      clearInterval(timer)
    }
  }
</script>

<style>

</style>
